/**
 * PublicationList
 */
import React from 'react';
/** Publication list component. */
var PublicationList = function (_a) {
    var children = _a.children;
    return (React.createElement(React.Fragment, null, children && (React.createElement("div", { "aria-live": "polite", "data-cid": "PublicationsList" }, children))));
};
export default PublicationList;
